
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lumi-parliament-playground",
      function () {
        return require("private-next-pages/lumi-parliament-playground.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lumi-parliament-playground"])
      });
    }
  